"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialFormEventsHelper = void 0;
const events_1 = require("@front/components/form-parts/events");
// Form fields synced automatically by FormComponent.listenForValuesChange
const AUTO_SYNCED_FIELDS = ['name', 'description', 'introText', 'tutorialGoal', 'expireAt', 'active', 'logo', 'hours'];
class TutorialFormEventsHelper {
    static bindEvents() {
        this.on(events_1.inputEvents.changed, (event) => {
            TutorialFormEventsHelper.handleInputChanged.call(this, event.detail);
        });
        this.on('file-part:clear', (event) => {
            TutorialFormEventsHelper.handleFileCleared.call(this, event.target);
        });
        this.on('chat:user_message_sent', () => {
            this.chatStarted = true;
        });
        this.on('chat:tool:detected', (e) => {
            var _a;
            const detail = e.detail;
            if (((_a = detail === null || detail === void 0 ? void 0 : detail.tool) === null || _a === void 0 ? void 0 : _a.toolName) === 'tutorialFormEdit' && detail.tool.data) {
                this.applyToolFormData(detail.tool.data);
            }
        });
        this.on('onboarding-submit', (e) => {
            this.onboardingAttached = e.detail;
            this.formStarted = true;
            this.updateChatTools();
        });
        this.on('go-to-step', (e) => {
            this.goToStep(e.detail.index);
        });
        this.on('go-to-section', (e) => {
            this.scrollToSection(e.detail.sectionIndex);
        });
        this.on('add-step', () => {
            this.addStep();
        });
    }
    static handleInputChanged({ fieldName, value }) {
        if (!fieldName || typeof fieldName !== 'string') {
            return;
        }
        if (AUTO_SYNCED_FIELDS.includes(fieldName)) {
            if (fieldName === 'tutorialGoal') {
                this.updateChatTools();
            }
            return;
        }
        // Hours
        if (fieldName === 'hours') {
            this.form.hours = value !== '' && value != null ? parseFloat(value) : null;
            this.form = { ...this.form };
            return;
        }
        // Scan page range inputs
        if (fieldName === 'scanPagesFrom' || fieldName === 'scanPagesTo') {
            this.form[fieldName] = value !== '' && value != null ? Number(value) : null;
            this.form = { ...this.form };
            this.updateChatTools();
            return;
        }
        if (fieldName === 'source') {
            this.form.source = value;
            this.form = { ...this.form };
            this.updateChatTools();
            return;
        }
        // Knowledge and uploaded file are alternative scan sources
        if (fieldName === 'scanKnowledgeId') {
            this.form.scanKnowledgeId = value ? value.toString() : null;
            if (this.form.scanKnowledgeId) {
                this.form.sourceFile = null;
            }
            this.form = { ...this.form };
            return;
        }
        if (fieldName === 'avatarId') {
            this.form.avatar = this.availableAvatars.find(a => { var _a; return ((_a = a.id) === null || _a === void 0 ? void 0 : _a.toString()) === (value === null || value === void 0 ? void 0 : value.toString()); }) || null;
            this.form = { ...this.form };
            this.updateChatTools();
            return;
        }
        if (fieldName === 'instructionFile') {
            this.form.instructionFile = value || null;
            this.form = { ...this.form };
            this.updateChatTools();
            return;
        }
        if (fieldName === 'categoryId') {
            this.form.categoryId = value ? Number(value) : null;
            this.form = { ...this.form };
            this.updateChatTools();
            return;
        }
        // Step field updates (format: step-field-stepIndex)
        if (fieldName.startsWith('step-')) {
            const [, field, stepIndex] = fieldName.split('-');
            this.updateStepField(parseInt(stepIndex), field, value);
            this.updateChatTools();
            return;
        }
        // Section field updates (format: section-field-stepIndex-sectionIndex)
        if (fieldName.startsWith('section-')) {
            const [, field, stepIndex, sectionIndex] = fieldName.split('-');
            this.updateSectionField(parseInt(stepIndex), parseInt(sectionIndex), field, value);
            this.updateChatTools();
            return;
        }
        // Todo item field updates (format: todo-field-stepIndex-sectionIndex-todoIndex)
        if (fieldName.startsWith('todo-')) {
            const [, field, stepIndex, sectionIndex, todoIndex] = fieldName.split('-');
            this.updateTodoItem(parseInt(stepIndex), parseInt(sectionIndex), parseInt(todoIndex), field, value);
            this.updateChatTools();
        }
    }
    static handleFileCleared(target) {
        if (!target || !target.name) {
            return;
        }
        if (target.name === 'logo' || target.name === 'instructionFile' || target.name === 'sourceFile') {
            this.form[target.name] = null;
            this.form = { ...this.form };
        }
    }
}
exports.TutorialFormEventsHelper = TutorialFormEventsHelper;
